import React, { useState } from 'react';
import { shareContent, shareToKakao } from '../../../utils/shareUtils';
import { trackEvent } from '../../../utils/eventTracker';

export const NEWS_SHARE_IMAGE = '/images/news/share-card.jpg';

/** 퀴즈·수업 아이디어를 동료 선생님께 보내는 버튼. 카카오톡이 안 되면 기본 공유, 그것도 안 되면 링크 복사. */
const NewsShareButton = ({ target, title, text, path, buttonTitle, subtle = false, children }) => {
  const [busy, setBusy] = useState(false);
  const [notice, setNotice] = useState('');

  const handleShare = async () => {
    if (busy) return;
    setBusy(true);
    setNotice('');
    const url = `${window.location.origin}${path}`;
    try {
      let result = await shareToKakao({
        title,
        text,
        url,
        imageUrl: `${window.location.origin}${NEWS_SHARE_IMAGE}`,
        imageWidth: 840,
        imageHeight: 840,
        buttonTitle,
      });
      if (!result.success) result = await shareContent({ title, text, url });
      trackEvent('news_share', { target, method: result.method || 'unknown' });
      if (result.method === 'clipboard') {
        setNotice('링크를 복사했어요. 카카오톡에 붙여넣어 보내 주세요.');
      } else if (!result.success && result.method !== 'cancelled') {
        setNotice('공유 창을 열지 못했어요. 잠시 후 다시 해 주세요.');
      }
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="news-share">
      <button
        type="button"
        className={`news-share-btn${subtle ? ' news-share-btn--subtle' : ''}`}
        onClick={handleShare}
        disabled={busy}
      >
        <svg aria-hidden="true" fill="none" height="18" viewBox="0 0 24 24" width="18">
          <path
            d="M12 4c-4.97 0-9 3.13-9 7 0 2.5 1.68 4.69 4.2 5.93L6.5 20l3.62-2.37c.61.08 1.24.12 1.88.12 4.97 0 9-3.13 9-7s-4.03-7-9-7Z"
            fill="currentColor"
          />
        </svg>
        {children}
      </button>
      {notice && <p className="news-share-notice" role="status">{notice}</p>}
    </div>
  );
};

export default NewsShareButton;
